export const AssignmentStatusTypes = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED"
};
